module.exports = __webpack_public_path__ + "static/greatwallofyarmouth-web-bb2a02d6d3e3b1ac4c301287dc60897f.jpg";